import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	confirmButtonLabel: {
		id: 'issue-field-single-line-text-inline-edit-full.single-line-text.confirm-button-label',
		defaultMessage: 'Confirm {fieldName}',
		description:
			'An accessibility label for a confirm button in an input field. The fieldName parameter refers to an optional heading for what the field is controlling. Pressing the button saves the contents of the input field.',
	},
	cancelButtonLabel: {
		id: 'issue-field-single-line-text-inline-edit-full.single-line-text.cancel-button-label',
		defaultMessage: 'Cancel {fieldName}',
		description:
			'An accessibility label for a cancel button in an input field. The fieldName parameter refers to an optional heading for what the field is controlling. Pressing the button reverts the contents of the input field to their previous value.',
	},
	editButtonLabel: {
		id: 'issue-field-single-line-text-inline-edit-full.single-line-text.edit-button-label',
		defaultMessage: 'Edit {fieldName}',
		description:
			'An accessibility label for an edit button in an input field. The fieldName parameter refers to an optional heading for what the field is controlling. Pressing the button allows the user to edit the contents of the input field.',
	},
	maxLengthErrorMessage: {
		id: 'issue-field-single-line-text-inline-edit-full.single-line-text.max-length-error-message',
		defaultMessage: '{maxLength} character limit',
		description:
			'Validation message shown to the user when the updated value exceeds the inputs max length.',
	},
	requiredErrorMessage: {
		id: 'issue-field-single-line-text-inline-edit-full.single-line-text.required-error-message',
		defaultMessage: '{fieldName} is required',
		description:
			'Validation message shown to the user when they attempt to clear a required field.',
	},
});
